[
  {
    "code": "DJ-AS",
    "name": "Ali Sabieh"
  },
  {
    "code": "DJ-AR",
    "name": "Arta"
  },
  {
    "code": "DJ-DI",
    "name": "Dikhil"
  },
  {
    "code": "DJ-DJ",
    "name": "Djibouti"
  },
  {
    "code": "DJ-OB",
    "name": "Obock"
  },
  {
    "code": "DJ-TA",
    "name": "Tadjourah"
  }
]